<template>
  <UiSelectElement
    :model-value="modelValue"
    :placeholder="$t('settings.currencies.allCurrencies')"
    :list="currencies"
    :disabled="disabled"
    class="ui-currency-picker"
    width="initial"
    :prepend-text="currencySymbol"
    option-value-param="code"
    option-label-param="code"
    option-name-param="name"
    :filterable="true"
    is-dynamic
    :prepend-icon="modelValue === '' ? 'money-bill-wave' : ''"
    @update:model-value="handleUpdateModelValue"
  />
</template>

<script>
import { find } from 'lodash-es';

export default {
  name: 'UiCurrencyPicker',
  emits: ['update:model-value'],
  props: {
    currencies: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    currencySymbol() {
      return find(this.currencies, ['code', this.modelValue])?.symbol || '';
    },
  },
  methods: {
    handleUpdateModelValue(code) {
      this.$emit('update:model-value', code);
    },
  },
};
</script>
